import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class InitRequestPayload extends RequestPayload {
}
